module.exports = __webpack_public_path__ + "media/default.33f0a046.mp4";